import type { SentimentLabel } from "@/types/sentiment";

export const CONFIDENCE_DISPLAY_THRESHOLD = 0.5;
export const SENTIMENT_POLL_INTERVAL_MS = 10_000;

export const SENTIMENT_LABEL_COLORS: Record<SentimentLabel, string> = {
  positive: "#2E7D32",
  neutral: "#9E9E9E",
  negative: "#C62828",
};

export const SENTIMENT_LABEL_GLYPH: Record<SentimentLabel, string> = {
  positive: "🟢",
  neutral: "🟡",
  negative: "🔴",
};
